/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-list-item-selected[_ngcontent-%COMP%]{background:#d3d3d3}.happ-list-item[_ngcontent-%COMP%]{padding:0 12px;cursor:pointer;border:1px solid #d3d3d3}.happ-list-item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}.happ-list-item[_ngcontent-%COMP%]:hover{background:#d3d3d3}.happ-bulk-desc[_ngcontent-%COMP%]{margin-left:12px}.happ-bulk-heading[_ngcontent-%COMP%]{margin:12px 0;padding:12px;border:1px solid #d3d3d3}  .happ-big-input input{font-size:32px;text-align:center}"];
export { styles as styles };
